import {
  PRESSURE_TO_PA, VOLFLOW_TO_M3S, POWER_TO_W, TORQUE_TO_NM, ENERGY_TO_J,
  LENGTH_TO_M, VOLUME_TO_M3, VELOCITY_TO_MS, AREA_TO_M2,
  VISCOSITY_DYNAMIC_TO_PAS, VISCOSITY_KINEMATIC_TO_M2S,
  DENSITY_TO_KGM3
} from '../units';

const TABLES: Record<string, Record<string, number>> = {
  pressure: PRESSURE_TO_PA,
  volflow: VOLFLOW_TO_M3S,
  power: POWER_TO_W,
  torque: TORQUE_TO_NM,
  energy: ENERGY_TO_J,
  length: LENGTH_TO_M,
  volume: VOLUME_TO_M3,
  velocity: VELOCITY_TO_MS,
  area: AREA_TO_M2,
  viscosity_dynamic: VISCOSITY_DYNAMIC_TO_PAS,
  viscosity_kinematic: VISCOSITY_KINEMATIC_TO_M2S,
  density: DENSITY_TO_KGM3
};

function findTable(fromU: string, toU: string): Record<string, number> | null {
  for (const table of Object.values(TABLES)) {
    if (fromU in table && toU in table) return table;
  }
  return null;
}

export function linearConvert(value: number, fromU: string, toU: string): number {
  const table = findTable(fromU, toU);
  if (!table) throw new Error(`Unknown unit or units from different families: ${fromU} → ${toU}`);
  const fromSI = table[fromU];
  const toSI = table[toU];
  if (fromSI === undefined || toSI === undefined) {
    throw new Error(`Unknown unit: ${fromU} or ${toU}`);
  }
  return (value * fromSI) / toSI;
}
